 import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

import * as api from '../../_apis_/service'

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  statusSource: null,
  onboardingStatus: null,
  onboardingData: {},
  providerDetails: null
};

const slice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ONBOARDING STATUS
    updateEventSuccess(state, action) {
      state.isLoading = false;
      state.statusSource = 'local';
      state.onboardingStatus = action.payload.status;
      state.onboardingData = Object.assign({}, state.onboardingData, action.payload.onboardingData);
    },

    // POST ONBOARDING STATUS - LOGGING
    postEventSuccess(state, action) {
      state.isLoading = false;
    },

    // GET PROVIDER DETAILS
    getProviderDetailsSuccess(state, action) {
      state.isLoading = false;
      state.providerDetails = action.payload;
    },

    // GET PROFILE
    getOnboardingStatusSuccess(state, action) {
      state.isLoading = false;
      state.statusSource = 'server';
      state.onboardingData = action.payload.onboardingData
      state.onboardingStatus = action.payload.onboardingStatus
    },

    // BANK ACCOUNT VERIFICATION RESPONSE
    bankAccountVerificationResponse(state, action) {
      state.isLoading = false;
      state.bankAcVerificationStatus = action.payload.status;
    },
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { updateOnboardingStatus } = slice.actions;

// ----------------------------------------------------------------------

export function getOnboardingStatus() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/account/onboarding/get_status');
      dispatch(slice.actions.getOnboardingStatusSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getProviderDetails(mobile) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/account/user/data_for_agreement');
      dispatch(slice.actions.getProviderDetailsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateEvent(event, attributes={}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/account/onboarding/update_event', {event, attributes});
      dispatch(slice.actions.updateEventSuccess({'status': event, 'onboardingData': attributes}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function postEvent(event, attributes={}) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/account/onboarding/update_event', {event, attributes});
      dispatch(slice.actions.postEventSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function verifyBankAccountDetails(accountDetails) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/account/onboarding/verify_bank_account', {accountDetails});
      dispatch(slice.actions.bankAccountVerificationResponse(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}